module.exports = __webpack_public_path__ + "img/tanom2.cb78dc3e.png";